import {useCallback, useEffect, useState} from "react";
import {Nullable} from "../../models/Common";
import FleetExpensesStore from "../../stores/FleetExpensesStore";
import {OptionMap} from "../../helpers/optionMap";

type TransportsResponse = {
  transports: Nullable<OptionMap<string>>;
  isLoading: boolean;
};

export function useFleetExpensesTransports(store: typeof FleetExpensesStore): TransportsResponse {
  const [loading, setLoading] = useState<boolean>(false);
  const [transports, setTransports] = useState<Nullable<OptionMap<string>>>(null);

  const fetchTransports = useCallback(async (): Promise<void> => {
    try {
      setLoading(true);
      const result: Nullable<OptionMap<string>> = await store.getTransports();
      setTransports(result);
    } catch {
      console.warn('Error when fetching transports');
      setTransports(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void fetchTransports();
  }, [fetchTransports]);

  return {
    transports,
    isLoading: loading,
  };
}